(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-clients-say"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.mySwiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 1
      },
      1024: {
        slidesPerView: 1
      },
      1199:{
        slidesPerView:1
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electro-footer-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-electro-fx]');
    if (!sections.length) return;

    /* ---- hex colour → normalised floats ---- */
    const hexToGL = (hex) => {
      hex = hex.replace('#', '');
      if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
      return [
        parseInt(hex.slice(0,2),16)/255,
        parseInt(hex.slice(2,4),16)/255,
        parseInt(hex.slice(4,6),16)/255
      ];
    };

    const cssColor = (el, prop) => {
      const v = getComputedStyle(el).getPropertyValue(prop).trim();
      if (v.startsWith('#')) return hexToGL(v);
      const m = v.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
      if (m) return [+m[1]/255, +m[2]/255, +m[3]/255];
      return [1, 1, 1];
    };

    /* ---- Vertex shader ---- */
    const VS = `
      attribute vec2 a_pos;
      void main() { gl_Position = vec4(a_pos, 0.0, 1.0); }
    `;

    /* ---- Fragment shader — lightning + mouse interaction ---- */
    const FS = `
      precision highp float;
      uniform float u_time;
      uniform vec2  u_res;
      uniform vec2  u_mouse;
      uniform float u_mouseActive;
      uniform vec3  u_glow;
      uniform vec3  u_arc;
      uniform vec3  u_particle;
      uniform float u_speed;
      uniform float u_density;
      uniform float u_arcCount;

      #define PI  3.14159265359
      #define TAU 6.28318530718

      /* ---- noise ---- */
      float hash(vec2 p) {
        return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453123);
      }

      float hash2(vec2 p) {
        return fract(sin(dot(p, vec2(269.5, 183.3))) * 43758.5453123);
      }

      float noise(vec2 p) {
        vec2 i = floor(p);
        vec2 f = fract(p);
        f = f * f * (3.0 - 2.0 * f);
        return mix(
          mix(hash(i), hash(i + vec2(1,0)), f.x),
          mix(hash(i + vec2(0,1)), hash(i + vec2(1,1)), f.x),
          f.y
        );
      }

      float fbm(vec2 p) {
        float v = 0.0, a = 0.5;
        mat2 rot = mat2(0.8, 0.6, -0.6, 0.8);
        for (int i = 0; i < 5; i++) {
          v += a * noise(p);
          p = rot * p * 2.0;
          a *= 0.5;
        }
        return v;
      }

      /* ---- lightning bolt with sub-branches ---- */
      float bolt(vec2 uv, vec2 a, vec2 b, float t, float width) {
        vec2 ab = b - a;
        float len = length(ab);
        if (len < 0.001) return 0.0;
        vec2 dir = ab / len;
        vec2 n = vec2(-dir.y, dir.x);
        vec2 ap = uv - a;
        float proj = dot(ap, dir);
        float along = clamp(proj / len, 0.0, 1.0);

        /* multi-frequency jagged displacement */
        float disp = 0.0;
        disp += (noise(vec2(along * 18.0 + t * 8.0, t * 2.5 + 0.0)) - 0.5) * 0.7;
        disp += (noise(vec2(along * 42.0 - t * 12.0, t * 3.7 + 5.0)) - 0.5) * 0.35;
        disp += (noise(vec2(along * 80.0 + t * 20.0, t * 5.0 + 10.0)) - 0.5) * 0.15;
        disp *= 0.06 * len;

        float fade = smoothstep(0.0, 0.08, along) * smoothstep(1.0, 0.92, along);
        float dist = abs(dot(ap, n) - disp);

        /* bright core + wide glow */
        float core = smoothstep(width * 1.2, 0.0, dist) * fade;
        float glow = smoothstep(width * 8.0, 0.0, dist) * 0.35 * fade;
        float bloom = smoothstep(width * 22.0, 0.0, dist) * 0.12 * fade;

        return core + glow + bloom;
      }

      /* ---- branching bolt system ---- */
      float lightningBolt(vec2 uv, vec2 start, vec2 end, float t, float seed) {
        float total = 0.0;

        /* main bolt */
        total += bolt(uv, start, end, t + seed, 0.003);

        /* sub-branches splitting off the main bolt */
        for (float j = 0.0; j < 4.0; j++) {
          float bAlong = 0.15 + hash(vec2(seed + j, 77.0)) * 0.7;
          vec2 branchStart = mix(start, end, bAlong);

          /* branch direction: angled off the main bolt */
          vec2 mainDir = normalize(end - start);
          vec2 mainNorm = vec2(-mainDir.y, mainDir.x);
          float angle = (hash(vec2(seed + j, 88.0)) - 0.5) * 2.5;
          vec2 branchDir = mainDir * cos(angle) + mainNorm * sin(angle);
          float branchLen = (0.06 + hash(vec2(seed + j, 99.0)) * 0.12);
          vec2 branchEnd = branchStart + branchDir * branchLen;

          /* branch visibility pulses */
          float bPulse = smoothstep(0.0, 0.5, sin(t * 4.0 + j * 3.7 + seed)) * 0.7;
          total += bolt(uv, branchStart, branchEnd, t + seed + j * 3.0, 0.002) * bPulse;
        }

        return total;
      }

      void main() {
        vec2 uv = gl_FragCoord.xy / u_res;
        float aspect = u_res.x / u_res.y;
        float t = u_time * u_speed;

        /* mouse in UV space */
        vec2 mouse = u_mouse / u_res;
        mouse.y = 1.0 - mouse.y;

        /* ---- atmospheric energy field ---- */
        float field = fbm(uv * 5.0 + vec2(t * 0.2, t * 0.1));
        field += 0.5 * fbm(uv * 10.0 - vec2(t * 0.35, t * 0.18));
        float energy = smoothstep(0.38, 0.72, field) * 0.22;

        /* mouse proximity brightens energy */
        float mouseDist = length((uv - mouse) * vec2(aspect, 1.0));
        float mouseGlow = smoothstep(0.5, 0.0, mouseDist) * u_mouseActive;
        energy += mouseGlow * 0.3;

        /* ---- ambient lightning bolts (vertical-biased) ---- */
        float arcs = 0.0;
        for (float i = 0.0; i < 8.0; i++) {
          if (i >= u_arcCount) break;

          /* start near top, end near bottom — strong vertical bias */
          float xBase = hash(vec2(i, 0.0));
          float xDrift = sin(t * 0.12 + i * 0.7) * 0.08;
          vec2 start = vec2(
            fract(xBase + xDrift + t * 0.015),
            0.7 + hash(vec2(i, 1.0)) * 0.3
          );
          /* end X stays close to start X for vertical look, small wander */
          vec2 end = vec2(
            fract(xBase + xDrift + (hash(vec2(i, 2.0)) - 0.5) * 0.15 + t * 0.015),
            hash(vec2(i, 3.0)) * 0.35
          );

          /* pulse in/out with sharp attack, slow fade */
          float phase = t * 0.7 + i * 2.1 + hash(vec2(i, 50.0)) * TAU;
          float pulse = pow(max(sin(phase), 0.0), 0.4) *
                        smoothstep(-0.1, 0.15, sin(phase));

          /* each bolt flickers — random on/off at high frequency */
          float flicker = step(0.2, hash(vec2(floor(t * 10.0 + i * 3.0), i)));

          arcs += lightningBolt(uv, start, end, t, i * 5.0) * pulse * flicker * 1.3;
        }

        /* ---- extra fast-flicker vertical streaks ---- */
        for (float i = 0.0; i < 6.0; i++) {
          float seed = hash(vec2(i + 20.0, 44.0));
          float xPos = fract(seed + t * 0.01 + sin(t * 0.2 + i) * 0.05);
          vec2 streakStart = vec2(xPos, 0.95);
          vec2 streakEnd = vec2(xPos + (hash(vec2(i, 55.0)) - 0.5) * 0.06, 0.05);

          /* very short duty cycle — these flash on briefly */
          float flashPhase = t * 1.2 + i * 1.7 + seed * TAU;
          float flash = pow(max(sin(flashPhase), 0.0), 4.0);
          float streakFlicker = step(0.6, hash(vec2(floor(t * 15.0 + i * 5.0), i + 30.0)));

          arcs += bolt(uv, streakStart, streakEnd, t * 2.0 + i * 7.0, 0.002) * flash * streakFlicker * 0.8;
        }

        /* ---- mouse-attracted lightning (vertical from top/bottom edges) ---- */
        float mouseArcs = 0.0;
        if (u_mouseActive > 0.1) {
          /* bolts from top edge down to cursor */
          for (float i = 0.0; i < 2.0; i++) {
            vec2 origin = vec2(
              mouse.x + sin(t * 2.0 + i * 3.5) * 0.08,
              1.0 + 0.02
            );
            vec2 target = mouse + vec2(
              sin(t * 3.0 + i * 2.0) * 0.015,
              cos(t * 2.5 + i * 1.7) * 0.015
            );
            float mFlicker = step(0.12, hash(vec2(floor(t * 14.0 + i * 7.0), i + 20.0)));
            float mPulse = 0.5 + 0.5 * sin(t * 2.0 + i * 2.5);
            mouseArcs += lightningBolt(uv, origin, target, t * 1.5, 10.0 + i * 3.0)
                       * mFlicker * mPulse * u_mouseActive;
          }
          /* bolts from bottom edge up to cursor */
          for (float i = 0.0; i < 2.0; i++) {
            vec2 origin = vec2(
              mouse.x + cos(t * 1.8 + i * 4.0) * 0.1,
              -0.02
            );
            vec2 target = mouse + vec2(
              cos(t * 2.8 + i * 1.5) * 0.015,
              sin(t * 3.2 + i * 2.3) * 0.015
            );
            float mFlicker = step(0.15, hash(vec2(floor(t * 12.0 + i * 5.0), i + 40.0)));
            float mPulse = 0.4 + 0.6 * sin(t * 1.8 + i * 3.0);
            mouseArcs += lightningBolt(uv, origin, target, t * 1.3, 14.0 + i * 3.0)
                       * mFlicker * mPulse * u_mouseActive;
          }
        }

        /* ---- spark particles ---- */
        float sparks = 0.0;
        float particleCount = u_density;
        for (float i = 0.0; i < 80.0; i++) {
          if (i >= particleCount) break;
          float seed = hash(vec2(i * 0.37, i * 0.73));
          vec2 pos = vec2(
            fract(seed + t * (0.015 + seed * 0.03)),
            fract(hash(vec2(i, 99.0)) + sin(t * 0.5 + seed * TAU) * 0.15)
          );

          /* particles drift toward mouse */
          if (u_mouseActive > 0.1) {
            vec2 toMouse = mouse - pos;
            float mDist = length(toMouse * vec2(aspect, 1.0));
            pos += toMouse * smoothstep(0.4, 0.0, mDist) * 0.08 * u_mouseActive;
          }

          float size = 0.0012 + seed * 0.0025;
          float brightness = 0.5 + 0.5 * smoothstep(-0.3, 0.3, sin(t * 2.5 + seed * TAU));
          /* twinkle */
          brightness *= 0.6 + 0.4 * step(0.3, hash(vec2(floor(t * 6.0 + i), i)));

          float d = length((uv - pos) * vec2(aspect, 1.0)) / aspect;
          sparks += smoothstep(size, 0.0, d) * brightness;
          sparks += smoothstep(size * 8.0, 0.0, d) * 0.06 * brightness;
        }

        /* ---- vertical gradient fade (top = transparent, bottom = visible) ---- */
        float vFade = smoothstep(0.0, 0.6, 1.0 - uv.y);

        /* ---- cursor glow hotspot ---- */
        float hotspot = 0.0;
        if (u_mouseActive > 0.1) {
          float hDist = length((uv - mouse) * vec2(aspect, 1.0));
          hotspot = smoothstep(0.15, 0.0, hDist) * 0.6 * u_mouseActive;
          hotspot += smoothstep(0.35, 0.0, hDist) * 0.15 * u_mouseActive;
        }

        /* ---- compose ---- */
        vec3 col = vec3(0.0);
        col += u_glow * energy * vFade;
        col += u_arc * arcs * vFade;
        col += u_arc * mouseArcs * vFade * 1.2;
        col += u_particle * sparks * vFade;
        col += mix(u_arc, vec3(1.0), 0.5) * hotspot * vFade;

        float alpha = clamp(
          energy * 1.5 + arcs * 1.2 + mouseArcs * 1.5 + sparks * 0.5 + hotspot,
          0.0, 1.0
        ) * vFade;

        /* ---- subtle film grain overlay ---- */
        float grain = hash(uv * u_res + vec2(fract(u_time * 100.0))) * 2.0 - 1.0;
        col += grain * 0.04;
        alpha = clamp(alpha + abs(grain) * 0.03 * vFade, 0.0, 1.0);

        gl_FragColor = vec4(col, alpha);
      }
    `;

    sections.forEach((section) => {
      const canvas = section.querySelector('[data-electro-fx-canvas]');
      if (!canvas) return;

      const gl = canvas.getContext('webgl', {
        alpha: true,
        premultipliedAlpha: false,
        antialias: false
      });
      if (!gl) return;

      /* data-attr settings */
      const speedRaw = parseFloat(section.dataset.speed || '10');
      const speed = speedRaw / 10.0;
      const density = parseFloat(section.dataset.density || '40');
      const arcCount = parseFloat(section.dataset.arcCount || '4');

      /* colours from CSS custom properties */
      const glowC  = cssColor(section, '--efx-glow');
      const arcC   = cssColor(section, '--efx-arc');
      const partC  = cssColor(section, '--efx-particle');

      /* compile shaders */
      const compile = (type, src) => {
        const s = gl.createShader(type);
        gl.shaderSource(s, src);
        gl.compileShader(s);
        if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
          console.warn('Electro FX shader error:', gl.getShaderInfoLog(s));
          return null;
        }
        return s;
      };

      const vs = compile(gl.VERTEX_SHADER, VS);
      const fs = compile(gl.FRAGMENT_SHADER, FS);
      if (!vs || !fs) return;

      const prog = gl.createProgram();
      gl.attachShader(prog, vs);
      gl.attachShader(prog, fs);
      gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) {
        console.warn('Electro FX link error:', gl.getProgramInfoLog(prog));
        return;
      }
      gl.useProgram(prog);

      /* fullscreen quad */
      const buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 1,-1, -1,1, 1,1]), gl.STATIC_DRAW);
      const aPos = gl.getAttribLocation(prog, 'a_pos');
      gl.enableVertexAttribArray(aPos);
      gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

      /* uniform locations */
      const uTime        = gl.getUniformLocation(prog, 'u_time');
      const uRes         = gl.getUniformLocation(prog, 'u_res');
      const uMouse       = gl.getUniformLocation(prog, 'u_mouse');
      const uMouseActive = gl.getUniformLocation(prog, 'u_mouseActive');
      const uGlow        = gl.getUniformLocation(prog, 'u_glow');
      const uArc         = gl.getUniformLocation(prog, 'u_arc');
      const uParticle    = gl.getUniformLocation(prog, 'u_particle');
      const uSpeed       = gl.getUniformLocation(prog, 'u_speed');
      const uDensity     = gl.getUniformLocation(prog, 'u_density');
      const uArcCount    = gl.getUniformLocation(prog, 'u_arcCount');

      gl.uniform3fv(uGlow, glowC);
      gl.uniform3fv(uArc, arcC);
      gl.uniform3fv(uParticle, partC);
      gl.uniform1f(uSpeed, speed);
      gl.uniform1f(uDensity, density);
      gl.uniform1f(uArcCount, arcCount);
      gl.uniform2f(uMouse, 0, 0);
      gl.uniform1f(uMouseActive, 0);

      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

      /* ---- mouse tracking ---- */
      let mouseX = 0, mouseY = 0;
      let targetMouseActive = 0;
      let currentMouseActive = 0;
      const MOUSE_EASE = 0.06;
      const MOUSE_FADE = 0.03;

      const updateMouse = (clientX, clientY) => {
        const rect = canvas.getBoundingClientRect();
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        mouseX = (clientX - rect.left) * dpr;
        mouseY = (clientY - rect.top) * dpr;
        targetMouseActive = 1.0;
      };

      section.addEventListener('mousemove', (e) => updateMouse(e.clientX, e.clientY));
      section.addEventListener('touchmove', (e) => {
        if (e.touches.length) {
          e.preventDefault();
          updateMouse(e.touches[0].clientX, e.touches[0].clientY);
        }
      }, { passive: false });

      section.addEventListener('mouseleave', () => { targetMouseActive = 0; });
      section.addEventListener('touchend', () => { targetMouseActive = 0; });

      /* ---- resize handling ---- */
      let w = 0, h = 0;
      const resize = () => {
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const rect = canvas.getBoundingClientRect();
        const nw = Math.round(rect.width * dpr);
        const nh = Math.round(rect.height * dpr);
        if (nw !== w || nh !== h) {
          w = nw; h = nh;
          canvas.width = w;
          canvas.height = h;
          gl.viewport(0, 0, w, h);
          gl.uniform2f(uRes, w, h);
        }
      };

      /* ---- visibility-gated animation ---- */
      let raf;
      let visible = false;

      const tick = (now) => {
        if (!visible) return;
        resize();

        /* ease mouse active in/out */
        if (targetMouseActive > currentMouseActive) {
          currentMouseActive += (targetMouseActive - currentMouseActive) * MOUSE_EASE;
        } else {
          currentMouseActive += (targetMouseActive - currentMouseActive) * MOUSE_FADE;
        }
        if (currentMouseActive < 0.001) currentMouseActive = 0;

        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.uniform1f(uTime, now * 0.001);
        gl.uniform2f(uMouse, mouseX, mouseY);
        gl.uniform1f(uMouseActive, currentMouseActive);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        raf = requestAnimationFrame(tick);
      };

      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !visible) {
          visible = true;
          raf = requestAnimationFrame(tick);
        } else if (!entry.isIntersecting && visible) {
          visible = false;
          if (raf) cancelAnimationFrame(raf);
        }
      }, { threshold: 0 });

      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electro-marquee-ticker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tickers = document.querySelectorAll('[data-electro-ticker]');
    if (!tickers.length) return;

    tickers.forEach((ticker) => {
      const track = ticker.querySelector('[data-animate-track]');
      if (!track) return;

      const pauseOnHover = ticker.dataset.pauseOnHover === 'true';
      if (!pauseOnHover) return;

      const pause = () => {
        track.style.animationPlayState = 'paused';
      };

      const resume = () => {
        track.style.animationPlayState = 'running';
      };

      ticker.addEventListener('mouseenter', pause);
      ticker.addEventListener('mouseleave', resume);
      ticker.addEventListener('focusin', pause);
      ticker.addEventListener('focusout', resume);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electro-media-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseVideoSource = (raw) => {
      const url = String(raw || '').trim();
      if (!url) return null;
      try {
        const u = new URL(url, window.location.href);
        const host = u.hostname.replace(/^www\./, '');

        if (host === 'youtu.be') {
          const id = u.pathname.split('/').filter(Boolean)[0];
          return id ? { kind: 'youtube', id } : null;
        }
        if (host.includes('youtube.com') || host === 'm.youtube.com') {
          if (u.pathname.startsWith('/embed/')) {
            const id = u.pathname.split('/')[2];
            return id ? { kind: 'youtube', id } : null;
          }
          if (u.pathname.startsWith('/shorts/')) {
            const id = u.pathname.split('/')[2];
            return id ? { kind: 'youtube', id } : null;
          }
          const v = u.searchParams.get('v');
          if (v) return { kind: 'youtube', id: v };
        }
        if (host.includes('vimeo.com')) {
          const m = u.pathname.match(/\/(?:video\/)?(\d+)/);
          if (m) return { kind: 'vimeo', id: m[1] };
        }

        return { kind: 'direct', url: u.href };
      } catch {
        return { kind: 'direct', url };
      }
    };

    const clearSlot = (slot) => {
      if (!slot) return;
      slot.querySelectorAll('iframe, video').forEach((el) => {
        if (el.tagName === 'VIDEO') {
          el.pause();
          el.removeAttribute('src');
          el.load();
        }
        el.remove();
      });
      slot.innerHTML = '';
    };

    const closeShell = (shell, options = {}) => {
      if (!shell || shell.hidden) return;
      const wrap = shell.closest('.electro-media-carousel__media-wrap');
      const slot = wrap?.querySelector('[data-emc-player-slot]');
      const playBtn = wrap?.querySelector('.electro-media-carousel__play[data-emc-video-url]');
      clearSlot(slot);
      shell.hidden = true;
      playBtn?.setAttribute('aria-expanded', 'false');
      if (options.focusPlay) playBtn?.focus({ preventScroll: true });
    };

    const openInlinePlayer = (playBtn) => {
      const raw = playBtn.getAttribute('data-emc-video-url');
      const wrap = playBtn.closest('.electro-media-carousel__media-wrap');
      const shell = wrap?.querySelector('[data-emc-player-shell]');
      const slot = wrap?.querySelector('[data-emc-player-slot]');
      if (!shell || !slot) return;

      document.querySelectorAll('[data-emc-player-shell]').forEach((s) => {
        if (s !== shell) closeShell(s);
      });

      clearSlot(slot);
      const src = parseVideoSource(raw);
      if (!src) return;

      if (src.kind === 'youtube') {
        const iframe = document.createElement('iframe');
        iframe.setAttribute(
          'src',
          `https://www.youtube-nocookie.com/embed/${encodeURIComponent(src.id)}?autoplay=1&playsinline=1&rel=0`
        );
        iframe.setAttribute('title', 'YouTube video');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        );
        slot.appendChild(iframe);
      } else if (src.kind === 'vimeo') {
        const iframe = document.createElement('iframe');
        iframe.setAttribute(
          'src',
          `https://player.vimeo.com/video/${encodeURIComponent(src.id)}?autoplay=1&playsinline=1`
        );
        iframe.setAttribute('title', 'Vimeo video');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        slot.appendChild(iframe);
      } else {
        const video = document.createElement('video');
        video.setAttribute('controls', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('preload', 'metadata');
        video.src = src.url;
        video.autoplay = true;
        slot.appendChild(video);
      }

      shell.hidden = false;
      playBtn.setAttribute('aria-expanded', 'true');
      const closeBtn = shell.querySelector('[data-emc-video-close]');
      closeBtn?.focus({ preventScroll: true });
    };

    const closeInlinePlayer = (closeBtn) => {
      const shell = closeBtn.closest('[data-emc-player-shell]');
      closeShell(shell, { focusPlay: true });
    };

    document.addEventListener('click', (e) => {
      const playBtn = e.target.closest('.electro-media-carousel__play[data-emc-video-url]');
      if (playBtn) {
        e.preventDefault();
        openInlinePlayer(playBtn);
        return;
      }
      const closeBtn = e.target.closest('[data-emc-video-close]');
      if (closeBtn) {
        e.preventDefault();
        closeInlinePlayer(closeBtn);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const openShell = document.querySelector('[data-emc-player-shell]:not([hidden])');
      if (openShell) closeShell(openShell, { focusPlay: true });
    });
  })();

  (() => {
    const tracks = document.querySelectorAll('[data-emc-track]');
    if (!tracks.length) return;

    tracks.forEach((track) => {
      const section = track.closest('.electro-media-carousel');
      const prev = section?.querySelector('[data-emc-prev]');
      const next = section?.querySelector('[data-emc-next]');
      const dotsWrap = section?.querySelector('[data-emc-dots]');
      const counter = section?.querySelector('[data-emc-counter]');
      const origCards = Array.from(track.children);
      const origLen = origCards.length;
      if (origLen < 2) return;

      let dots = [];

      /* ---- Append clones for seamless infinite scroll ---- */
      origCards.forEach(card => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.classList.add('emc-clone');
        track.appendChild(clone);
      });

      const allCards = Array.from(track.children);

      /* ---- Dots (original count only) ---- */
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        origCards.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'electro-media-carousel__dot';
          dot.setAttribute('aria-label', `Go to media ${i + 1}`);
          dot.addEventListener('click', () => smoothTo(i));
          dotsWrap.appendChild(dot);
        });
        dots = Array.from(dotsWrap.children);
      }

      /* ---- Scroll helpers ---- */
      const smoothTo = (idx) => {
        const card = allCards[idx];
        if (!card) return;
        track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };

      const jumpTo = (idx) => {
        const card = allCards[idx];
        if (!card) return;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = card.offsetLeft - track.offsetLeft;
        requestAnimationFrame(() => { track.style.scrollSnapType = ''; });
      };

      const nearestIndex = () => {
        const left = track.scrollLeft;
        let nearest = 0, best = Infinity;
        allCards.forEach((card, i) => {
          const d = Math.abs(card.offsetLeft - track.offsetLeft - left);
          if (d < best) { best = d; nearest = i; }
        });
        return nearest;
      };

      const toOrig = (idx) => ((idx % origLen) + origLen) % origLen;

      const syncUI = () => {
        const cur = toOrig(nearestIndex());
        if (counter) counter.textContent = `${cur + 1} / ${origLen}`;
        dots.forEach((dot, i) => dot.setAttribute('aria-current', i === cur ? 'true' : 'false'));
      };

      /* ---- Active card states via IntersectionObserver ---- */
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              entry.target.setAttribute('data-active', entry.isIntersecting ? 'true' : 'false');
            });
          },
          { root: track, threshold: 0.55 }
        );
        allCards.forEach((card) => observer.observe(card));
      }

      /* ---- Snap back from clone zone after scroll settles ---- */
      const snapToReal = () => {
        const idx = nearestIndex();
        if (idx >= origLen) jumpTo(idx - origLen);
      };

      let scrollTimer;
      track.addEventListener('scroll', () => {
        syncUI();
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(snapToReal, 120);
      }, { passive: true });

      /* ---- Prev / Next (infinite) ---- */
      prev?.addEventListener('click', () => {
        const cur = nearestIndex();
        if (cur <= 0) {
          jumpTo(origLen);
          requestAnimationFrame(() => requestAnimationFrame(() => smoothTo(origLen - 1)));
        } else {
          smoothTo(cur - 1);
        }
      });

      next?.addEventListener('click', () => {
        smoothTo(nearestIndex() + 1);
      });

      /* ---- Keyboard navigation (infinite) ---- */
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          smoothTo(nearestIndex() + 1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const cur = nearestIndex();
          if (cur <= 0) {
            jumpTo(origLen);
            requestAnimationFrame(() => requestAnimationFrame(() => smoothTo(origLen - 1)));
          } else {
            smoothTo(cur - 1);
          }
        }
      });

      syncUI();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electro-tabbed-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tabRoots = document.querySelectorAll('[data-etr-tabs]');
    if (!tabRoots.length) return;

    tabRoots.forEach((root) => {
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('[role="tabpanel"]')];
      if (!tabs.length) return;

      const activate = (index) => {
        tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          panels[i]?.toggleAttribute('hidden', !selected);
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));

        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let target = index;

          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;

          activate(target);
          tabs[target].focus();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electro-testimonial-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-etc-carousel]');
    if (!carousels.length) return;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-etc-track]');
      if (!track) return;

      const origCards = Array.from(track.children);
      const origLen = origCards.length;
      if (origLen < 2) return;

      const prev = carousel.querySelector('[data-etc-prev]');
      const next = carousel.querySelector('[data-etc-next]');
      const dotsContainer = carousel.parentElement.querySelector('[data-etc-dots]');
      const counter = carousel.parentElement.querySelector('[data-etc-counter]');
      let dotButtons = [];

      /* ---- Append clones for seamless infinite scroll ---- */
      origCards.forEach(card => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.classList.add('etc-clone');
        track.appendChild(clone);
      });

      const allCards = Array.from(track.children);

      /* ---- Dots (original count only) ---- */
      if (dotsContainer) {
        dotsContainer.innerHTML = '';
        origCards.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'electro-testimonial-cards__dot';
          dot.setAttribute('aria-label', `Go to testimonial ${index + 1}`);
          dot.addEventListener('click', () => smoothTo(index));
          dotsContainer.appendChild(dot);
        });
        dotButtons = Array.from(dotsContainer.children);
      }

      /* ---- Scroll helpers ---- */
      const smoothTo = (idx) => {
        const card = allCards[idx];
        if (!card) return;
        track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };

      const jumpTo = (idx) => {
        const card = allCards[idx];
        if (!card) return;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = card.offsetLeft - track.offsetLeft;
        requestAnimationFrame(() => { track.style.scrollSnapType = ''; });
      };

      const nearestIndex = () => {
        const left = track.scrollLeft + 2;
        let nearest = 0, best = Infinity;
        allCards.forEach((card, i) => {
          const d = Math.abs(card.offsetLeft - track.offsetLeft - left);
          if (d < best) { best = d; nearest = i; }
        });
        return nearest;
      };

      const toOrig = (idx) => ((idx % origLen) + origLen) % origLen;

      const syncDots = () => {
        const cur = toOrig(nearestIndex());
        if (counter) counter.textContent = `${cur + 1} / ${origLen}`;
        dotButtons.forEach((dot, i) => {
          dot.setAttribute('aria-current', i === cur ? 'true' : 'false');
        });
      };

      /* ---- Snap back from clone zone after scroll settles ---- */
      const snapToReal = () => {
        if (isMobile()) return;
        const idx = nearestIndex();
        if (idx >= origLen) jumpTo(idx - origLen);
      };

      let scrollTimer;
      track.addEventListener('scroll', () => {
        syncDots();
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(snapToReal, 120);
      }, { passive: true });

      /* ---- Prev / Next (infinite) ---- */
      prev?.addEventListener('click', () => {
        const cur = nearestIndex();
        if (cur <= 0) {
          jumpTo(origLen);
          requestAnimationFrame(() => requestAnimationFrame(() => smoothTo(origLen - 1)));
        } else {
          smoothTo(cur - 1);
        }
      });

      next?.addEventListener('click', () => {
        smoothTo(nearestIndex() + 1);
      });

      /* ---- Autoplay ---- */
      let timer;
      const autoplayOn = carousel.dataset.autoplay === 'true';
      const interval = Number(carousel.dataset.interval || 5000);
      const stopAutoplay = () => { if (timer) clearInterval(timer); };

      const startAutoplay = () => {
        if (!autoplayOn || origLen < 2 || isMobile()) return;
        stopAutoplay();
        timer = setInterval(() => smoothTo(nearestIndex() + 1), interval);
      };

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);

      syncDots();
      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.electro-footer__newsletter-form').forEach((form) => {
      const field = form.querySelector('.electro-footer__newsletter-field');
      const input = form.querySelector('.electro-footer__newsletter-input');
      const submit = form.querySelector('.electro-footer__newsletter-submit');
      if (!field || !input || !submit) return;

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        if (!input.value || !input.validity.valid) {
          input.focus();
          field.setAttribute('data-state', 'error');
          setTimeout(() => field.removeAttribute('data-state'), 2500);
          return;
        }

        field.setAttribute('data-state', 'loading');
        submit.disabled = true;

        try {
          await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
          });

          field.setAttribute('data-state', 'success');
          input.value = '';

          setTimeout(() => {
            field.removeAttribute('data-state');
            submit.disabled = false;
          }, 3500);
        } catch {
          field.setAttribute('data-state', 'error');
          submit.disabled = false;

          setTimeout(() => {
            field.removeAttribute('data-state');
          }, 3000);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
